import React, { Component } from "react";
import PropTypes from "prop-types";
import { FONT_FAMILIES } from "../../assets/consts/faCharCodes";
import Text from "./TextFont";
const DEFAULT_SIZE = 16;
const DEFAULT_COLOR = "#000";
/**@augments{Component<Props,state>} */
class FontAwesomeIcon extends Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    size: PropTypes.number,
    iconSize: PropTypes.number,
    color: PropTypes.string,
    style: PropTypes.oneOfType([
      PropTypes.shape(),
      PropTypes.array,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
    ]),
    lite: PropTypes.bool,
  };

  render() {
    return (
      <Text
        style={[
          {
            fontFamily: this.props.lite
              ? FONT_FAMILIES.PRO_LIGHT
              : FONT_FAMILIES.PRO_REGULAR,
            fontSize: this.props.size || DEFAULT_SIZE,
            color: this.props.color || DEFAULT_COLOR,
          },
          this.props.style,
        ]}
      >
        {this.props.icon}
      </Text>
    );
  }
}

export default FontAwesomeIcon;
